module.exports = __webpack_public_path__ + "img/dox-registration-success-nodox.f4471274.gif";